// mainContentsの幅とwindow幅からスライド幅を計算
export function calcSlideWidth(
  mainContentsSelector = '#mainContents',
  // 48: 左右のpadding, 80: サイドバー等の余白
  basePadding = 48 + 80,
  // 1画面あたりのスライド枚数: large: PC表示時, small: タブレット等の表示時
  // 見切れ(0.3, 0.2)を表示することでスライド可能であることを示唆
  slideCount = { large: 4.3, small: 3.2 },
  // デフォルトの最小幅（推奨される最小値）
  defaultMinWidth = 250
) {
  const windowWidth = window.innerWidth;
  const mainContentsElement = document.querySelector(mainContentsSelector);
  if (!mainContentsElement) return defaultMinWidth;

  const mainContentsWidth = (mainContentsElement.offsetWidth - basePadding);
  if (mainContentsWidth <= defaultMinWidth) return defaultMinWidth;

  const isLargeScreen = (windowWidth > 1286);
  const targetSlideCount = isLargeScreen ? slideCount.large : slideCount.small;
  return Math.floor(mainContentsWidth / targetSlideCount);
}

// 指定セレクタ配下の.m_linkCard要素のwidthを一括設定
export function setLinkCardWidth(parentSelector, width) {
  const parentElement = document.querySelector(parentSelector);
  if (!parentElement) return;

  parentElement.querySelectorAll('.m_linkCard').forEach(cardElement => {
    cardElement.style.width = width + 'px';
  });
}
